import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import logo from '../../assets/images/tcn-logo.svg';
import Footer from '../../components/Footer';
import validateForm from './validateForm.helper';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';

import Notify from '../../components/notify';
import Loader from '../../components/loader';
import { generateOtpAPI } from '../../services/api';
import { getMfaToken } from '../../helpers/localStorage';

export default function OneTimePassword() {
  const [openNotification, setOpenNotify] = useState(false);
  const [email, setEmail] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const mfaToken = getMfaToken();
    if (!mfaToken) {
      history.push('/login');
    }
  }, []);

  const handleRedirectToLogin = () => {
    history.push('/otp-mfa/login');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const mfaToken = getMfaToken();
    const payload = { email, token: mfaToken };
    const validate = validateForm(payload);
    if (validate.hasError) {
      setValidationErrors(validate);
      return;
    }
    setLoading(true);

    try {
      await generateOtpAPI(payload);
      setLoading(false);
      setSubmitted(true);
    }
    catch (err) {
      setErrors(err);
      setLoading(false);
      setOpenNotify(true);
    };
  };

  return (
    <>
      <Container
        component="main"
        className={(submitted ? "forget-container" : "forget-password-container") + " flex-col container"}
      >
        <CssBaseline />
        <div className="flex flex-col items-center forget-password-wrapper">
          <Avatar className="avatar">
            <img src={logo} alt="login-logo"></img>
          </Avatar>
          {submitted ? (<div className="info-text">
            An email has been sent to your TCN Admin user email address with your OTP<br />
            Click in the email or <a href="/otp-mfa/login" className="info-text-yellow" onClick={handleRedirectToLogin}>click here to proceed to your MFA login page</a>
          </div>) : (<form
            className="forget-password-form"
            noValidate
            onSubmit={handleSubmit}
          >
            <TextField
              error={validationErrors.email}
              required
              fullWidth
              id="email"
              label="Enter an authorized email address"
              name="email"
              value={email}
              type="email"
              autoFocus
              onChange={(e) => setEmail(e.target.value)}
              className="login-field"
              helperText="*Is required."
            />
            <Button
              type="submit"
              fullWidth
              className="submit-btn"
              disabled={loading}
              endIcon={
                <ArrowForwardOutlinedIcon style={{ color: '#FFFB00' }} />
              }
            >
              Send OTP
            </Button>
          </form>)}
        </div>
      </Container>
      <Footer />
      <Notify
        open={openNotification}
        onClose={() => setOpenNotify(false)}
        errors={errors}
        successMessage="Password reset link has been sent to your email!"
      />
      <Loader loading={loading} />
    </>

  );
};
